/**
 * quizChoices — les réponses d'une question de quiz telles que l'élève les voit : leur version à
 * formules quand elle les suit rang pour rang, sinon leur texte simple. Le texte simple reste ce que
 * l'app renvoie et que le serveur juge, au même rang. Une règle pour les trois quiz : le quiz de
 * prérequis, sa relecture et le défi éclair.
 */
export function shownChoicesOf(plain: string[], display: unknown[] | null | undefined): string[] {
    return Array.isArray(display) && display.length === plain.length
        ? display.map((choice) => String(choice ?? ""))
        : plain
}
